import { useQuery } from "@tanstack/react-query";
import { AIAgent } from "@graylog/enterprise-api";
const TOKEN_USAGE_BREAKDOWN_QUERY_KEY = ["aiagent", "workflow-runs", "token-usage", "breakdown"];
const filterValues = (values) => values != null ? values : [];
const fetchTokenUsageBreakdown = (filters) => {
  const request = {
    timerange: filters.timerange,
    type: filterValues(filters.type),
    provider: filterValues(filters.provider),
    model: filterValues(filters.model)
  };
  return AIAgent.tokenUsageBreakdown(request);
};
const useTokenUsageBreakdown = (filters) => useQuery({
  queryKey: [...TOKEN_USAGE_BREAKDOWN_QUERY_KEY, filters],
  queryFn: () => fetchTokenUsageBreakdown(filters),
  // Cache for a minute so focus changes or extra mounts don't re-run this heavy aggregation...
  staleTime: 6e4,
  // ...but always refresh on page re-entry, so switching tabs shows runs that happened meanwhile
  refetchOnMount: "always"
});
export default useTokenUsageBreakdown;
